import { FC } from 'react';
import { AmlCheckItemData } from '@/redux/models';
import { useTranslation } from 'react-i18next';
import styles from './AmountInfo.module.sass';

interface AmountInfoProps {
  isLoading?: boolean;
  item: AmlCheckItemData;
}

const AmountInfo: FC<AmountInfoProps> = ({ item, isLoading }) => {
  const data = item.amountData;
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.general}>
      <div className={styles.general__title}>{item?.direction}</div>
      <div className={styles.general__list}>
        <dl>
          <dd>
            {data?.amount || item.amount}&nbsp;{data?.asset}
          </dd>
        </dl>
        {data?.hasRiskyAmount && (
          <dl>
            <dt>{t('translation.amlhistory_table_risky')}</dt>
            <dd>
              {data?.riskyUsd && <>{data?.riskyUsd}&nbsp;•&nbsp;</>}
              {data?.riskyAmount}&nbsp;{data?.asset}
            </dd>
          </dl>
        )}
      </div>
    </div>
  );
};

export default AmountInfo;
